export default __webpack_public_path__ + "static/media/powerpoint.010e2715.svg";